import { provide } from '@/functions/log/views';

import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin((_nuxtApp) => {
  return {
    provide,
  };
});
